import { store } from "tsx/store";

import { trimObject } from "helpers/object";
import { parsePayload as parseFormPayload } from "services/api/contact-forms/contact-forms-api";
import { IUpdateContactFormPayload } from "store/entities/contact-forms/interfaces";
import {
  ILicenseFlags,
  ILicenseSourceParams,
  ISetSourceFirstClick,
  selectLicenseId as getLicenseIdSelector,
} from "store/entities/license";
import { IUpdateDefaultMailboxPayload } from "store/views/settings/interfaces";

import { IKeyAny, IRequestResult } from "../api-client";
import { BaseApi } from "../base";

function getLicenseId(): string {
  return String(getLicenseIdSelector(store.getState()));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function parseCreateLicenseParams(
  planCode: string,
  couponCode: string | null,
  sourceParams: ILicenseSourceParams
) {
  const params: IKeyAny = { planCode };

  if (couponCode !== null) {
    params.couponCode = couponCode;
  }

  if (Object.keys(sourceParams).length > 0) {
    const trimmedSourceParams = trimObject(sourceParams);
    if (Object.keys(trimmedSourceParams).length > 0) {
      params.source = trimObject(sourceParams);
    }
  }

  return params;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const deserializeDefaultMailboxPayload = ({ description, ...rest }: IUpdateDefaultMailboxPayload) => ({
  ...rest,
  defaultMailboxDescription: description,
});

export default class LicenseApi extends BaseApi {
  protected readonly prefix = "licenses";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCollection = () => this.get();
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (id: string) => this.get(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (planCode: string, couponCode: string | null, sourceParams: ILicenseSourceParams) =>
    this.post("", parseCreateLicenseParams(planCode, couponCode, sourceParams));

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  verify = (salt: string, hash: string) => this.post("verify", { salt, payload: hash });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultMailbox = (payload: IUpdateDefaultMailboxPayload) =>
    this.patch(getLicenseId(), { settings: deserializeDefaultMailboxPayload(payload) });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultTeam = (teamId: string) => this.patch(getLicenseId(), { defaultTeamID: teamId });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultTemplate = (defaultTemplateId: string) =>
    this.patch(getLicenseId(), { defaultTemplateID: defaultTemplateId });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultContactForm = (payload: IUpdateContactFormPayload) =>
    this.patch(getLicenseId(), { settings: { contactFormDefaults: parseFormPayload(payload).settings } });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateCompanyName = (companyName: string) =>
    this.patch(getLicenseId(), {
      settings: {
        companyName,
      },
    });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateUkraineSupportFooter = (supportUkraineFooter: boolean) =>
    this.patch(getLicenseId(), {
      settings: {
        supportUkraineFooter,
      },
    });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updatePoweredByFooter = (poweredByFooter: boolean) =>
    this.patch(getLicenseId(), {
      settings: {
        poweredByFooter,
      },
    });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updatePartnerId = (partnerId: string) =>
    this.patch(getLicenseId(), {
      settings: {
        partnerID: partnerId,
      },
    });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateSourceFirstClick = (sourceFirstClick: ISetSourceFirstClick) =>
    this.patch(getLicenseId(), {
      sourceFirstClick,
    });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  clearGoogleForwarding = () =>
    this.patch(getLicenseId(), {
      settings: {
        googleForwarding: null,
      },
    });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  sendForwardingInstructions = (email: string) => this.put(`${getLicenseId()}/forwardingInstructions`, { email });

  setLicenseFlag = (flag: keyof ILicenseFlags, hash: string, value: boolean): Promise<IRequestResult<void>> =>
    this.patch(getLicenseId(), {
      flags: {
        [`${flag}_${hash}`]: value,
      },
    });
}
